import React, { useMemo } from 'react'
import injectSheet from 'react-jss'
import styles from './slide.styles'
import Slide from '../../../components/slide/slide.jsx'
import LineBreak from 'pobble-components/dist/line-break'
import Heading from '../../../components/heading/heading.jsx'
import { withPresentation } from '../../../presentation-connectors'

const LessonOverview = ({ classes, slides, id }) => {
  const data = slides[id]

  const slideData = useMemo(
    () => ({
      body: data.body
    }),
    [data]
  )

  return (
    <Slide className={classes.container}>
      <Heading>
        <LineBreak>{slideData.body}</LineBreak>
      </Heading>
    </Slide>
  )
}

export default withPresentation(injectSheet(styles)(LessonOverview))
